import { IDossierItem } from "dto/Dossier/IDossierItem";
import { ItemKind } from "dto/IKindItems";

export const getDossierItemFileName = (item: IDossierItem) => {
  if (item && item.Label) {
    return item.Label;
  }

  return item.FileName ?? "";
};

export const getDossierItemRealFileName = (item: IDossierItem) => {
  return item.FileName ?? "";
};

export const getDossierItemGroupName = (item?: IDossierItem): string => {
  if (!item) return null;

  if (item.IsTemplate) {
    return "Szablony";
  }

  if (item.Kind === ItemKind.DossierFolder) {
    return "Foldery";
  }

  if (item.Kind === ItemKind.DossierLink) {
    return "Linki";
  }

  if (item.SignedPdfUri || item.SignedXadesUri) {
    return "Podpisane";
  }

  const fname = getDossierItemRealFileName(item);

  if (fname.toLocaleLowerCase().indexOf("sig") !== -1) {
    return "Podpisane";
  }

  const name = fname.split(".");
  const extenstion = name[name.length - 1];

  switch (extenstion.toLocaleLowerCase()) {
    case "jpg":
    case "png":
      return "Obrazy";
    case "xlsx":
      return "Arkusze kalkulacyjne";
    case "pdf":
      return "Dokumenty PDF";

    case "doc":
    case "docx":
    case "txt":
      return "Dokumenty";
    case "ppt":
    case "pptx":
      return "Prezentacje";
    default:
      return "Inne";
  }
};

export const getDossierItemGroupSortOrder = (groupName: string): number => {
  switch (groupName) {
    case "Dokumenty":
      return 1;
    case "Podpisane":
      return 2;
    case "Szablony":
      return 3;
    case "Dokumenty PDF":
      return 20;
    case "Obrazy":
      return 60;
    case "Arkusze kalkulacyjne":
      return 40;

    case "Prezentacje":
      return 30;
    case "Inne":
      return 99;
    case "Linki":
      return 50;

    case "Foldery":
      return 0;
    default:
      return 9999;
  }
};
